import React, { useEffect, useRef } from "react";
import "./ChipWithEllipse.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import TextWithTooltip from "../../GlobalContacts/TextWithTooltip";



function ChipWithEllipse({ data }) {
  const chipRef = useRef(null);

  // useEffect(() => {
   
  //   if (chipRef.current && window.bootstrap?.Tooltip) {
  //     new window.bootstrap.Tooltip(chipRef.current);
  //   }
  // }, []);

  return (
    // <div
    //   ref={chipRef}
    //   className="opp-tag gray"
    //   data-bs-toggle="tooltip"
    //   data-bs-placement="top"
    //   title={data}
    // >
    //   <span className="chip-text">{data}</span>
    // </div>
    <TextWithTooltip text={data} className="opp-tag gray chip-text"/>
  );
}
export default ChipWithEllipse;


